import { useEffect, useState } from 'react'

import Dropdown from 'ageas-react-component-dropdownlist'

import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useDocumentStore } from '../../../Stores/useDocumentStore'
import { useQuotationMessageUpdateStore } from '../../../Stores/useQuotationMessageUpdateStore'
import { useQuotationStore } from '../../../Stores/useQuotationStore'
import { CONTEXT_DOCUMENT } from '../../../constants/contextDocument'
import { t } from '../../../i18n'
import { Dropzone } from '../../Dropzone'
import { Minus, Plus, Trash } from '../../Icons'
import { Spacer } from '../styles'
import { FileProps } from './TableAttachment'
import { documentOptionsUpload, sharedDocuments } from './documentsOptions'

type Props = {
  item: FileProps
  context: string
  onCallback?: () => void
  disabled?: boolean
}

export const RowAttachment = ({
  context,
  item,
  onCallback,
  disabled,
}: Props) => {
  const [expanded, setExpanded] = useState(false)
  const [documentType, setDocumentType] = useState('')
  const [file, setFile] = useState<FileProps>()
  const { quotation, setQuotation, deleteAttachments } = useQuotationStore()
  const { quotationUpdate, setQuotationUpdate, deleteUpdateAttachments } =
    useQuotationMessageUpdateStore()
  const { addDocument, removeDocument } = useDocumentStore()
  const { createProposal } = useCreateProposalStore()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()

  const documentOptions =
    context === CONTEXT_DOCUMENT.CONFIRMATION_UPLOAD
      ? documentOptionsUpload
      : sharedDocuments

  const handleAddFile = (_file: FileProps) => {
    setFile(_file)
    if (context === CONTEXT_DOCUMENT.QUOTATION_REQUEST) {
      setQuotation({
        ...quotation,
        attachments: [
          ...(quotation?.attachments || []),
          {
            id: item.id,
            documentContent: _file.content,
            documentName: _file.name,
            documentType,
          },
        ],
      })
    } else if (context === CONTEXT_DOCUMENT.QUOTATION_UPDATE) {
      setQuotationUpdate({
        ...quotationUpdate,
        attachments: [
          ...(quotationUpdate?.attachments || []),
          {
            id: item.id,
            documentContent: _file.content,
            documentName: _file.name,
            documentType,
          },
        ],
      })
    } else if (context === CONTEXT_DOCUMENT.CONFIRMATION_UPLOAD) {
      addDocument({
        documentId: item.id.toString(),
        file: _file.content,
        uploadBy: 'Policy', //TODO: Review if will be static for context
        fileDescription: _file.name,
        docType: documentType,
        user: policyholderDetailsSelected?.idEntity,
        number: createProposal?.createProposalResponse?.proposalId,
      })
    }

    onCallback && onCallback()
  }

  const handleDeleteFile = (id: number) => {
    if (context === CONTEXT_DOCUMENT.QUOTATION_REQUEST) {
      deleteAttachments(id)
    } else if (context === CONTEXT_DOCUMENT.QUOTATION_UPDATE) {
      deleteUpdateAttachments(id)
    } else if (context === CONTEXT_DOCUMENT.CONFIRMATION_UPLOAD) {
      removeDocument(id.toString())
    }
  }

  useEffect(() => {
    return () => URL.revokeObjectURL(file?.preview!)
  }, [])

  return (
    <>
      <tr>
        <td>{item.id}</td>
        <td className="ellipse-text">{file?.name}</td>
        <td className="td-right">
          {documentOptions.find((i) => i.value === documentType)?.caption}
        </td>
        <td>
          <div className="action">
            <button
              className="button"
              disabled={disabled}
              onClick={() => handleDeleteFile(item.id)}
            >
              <Trash />
            </button>
            {!Boolean(file?.path) ? (
              <button
                className="button"
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? <Minus /> : <Plus />}
              </button>
            ) : (
              <Spacer />
            )}
          </div>
        </td>
      </tr>
      {expanded && !Boolean(file?.path) && (
        <tr>
          <td colSpan={4}>
            <div className="dropdown">
              <Dropdown
                id="r-type"
                name="type"
                label={t('pages.step7.attachmentDocuments.typeFile')}
                colorTheme="blue"
                readOnly={disabled}
                value={documentType}
                options={documentOptions}
                version="2"
                onValueChanged={(id: string, value: string) => {
                  setDocumentType(value)
                }}
              />
            </div>
            {Boolean(documentType) && !disabled && (
              <Dropzone onChange={handleAddFile} />
            )}
          </td>
        </tr>
      )}
    </>
  )
}
